import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUser } from '@shared/interfaces';
import { UserService } from '@shared/services/user.service';
import { IPaginatedResult } from '@shared/interfaces/mailing/IPaginatedResult';
import { PageEvent } from '@angular/material/paginator';
import { IQueryUser } from '@shared/interfaces/queries/IQueryUser';
import { GuardService } from '@shared/services';

const IMPERSONATION = 'impersonation';

@Component({
    selector: 'app-user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
    standalone: false
})
export class UserSettingsComponent implements OnInit, OnDestroy {
    queryString: string;
    users: IPaginatedResult<IUser>;
    loading = false;

    constructor(
        public dialogRef: MatDialogRef<UserSettingsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { currentUser: IUser },
        private userService: UserService,
        private guardService: GuardService
    ) {}

    get impersonatedUser(): string {
        return localStorage.getItem(IMPERSONATION);
    }

    ngOnInit(): void {
        this.loadItems();

        document.body.onclick = (e: PointerEvent) => {
            if (e && e.composedPath().some((a: HTMLElement) => a && a.tagName === 'MAIN')) {
                const overlays = document.getElementsByClassName('dialog-side-panel');
                for (const overlay of Array.from(overlays)) {
                    overlays[overlays.length - 1].animate(
                        [{ transform: 'translateX(0)' }, { transform: 'translateX(510px)' }],
                        { duration: 300, iterations: 1 }
                    );
                }
                this.dialogRef.close();
            }
        };
    }

    ngOnDestroy() {
        document.body.onclick = null;
    }

    async loadItems(pageEvent?: PageEvent) {
        const query: IQueryUser = {
            pagination: {
                pageSize: this.users?.pageSize ?? 16,
                page: pageEvent?.pageIndex ?? 0
            },
            query: this.queryString ?? null
        };

        this.users = await this.userService.getAllUsersFlat(query);
    }

    protected impersonate(user: IUser): void {
        if (this.impersonatedUser === user.id) {
            return;
        }

        if (this.guardService.mainUser && user.id === this.guardService.mainUser.id) {
            // if the user clicks on their own name, we want to remove impersonation
            this.userService.removeImpersonation();
        } else {
            this.userService.setImpersonation(user.id);
        }
        window.location.reload();
    }
}
